import React from 'react'

import { OptimizedAsset } from './OptimizedAsset'

type IconProps = {
  size?: number
  className?: string
}

export default function PacketShieldIcon({
  size = 20,
  className
}: IconProps) {
  return (
    <OptimizedAsset
      source="/images/icons/packetshield.png"
      avif="/images/icons/packetshield.avif"
      webp="/images/icons/packetshield.webp"
      alt="PacketShield"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  )
}
